export const BRANDS = {
  MABRA: 'mabra',
  HANT: 'hant',
  ALLAS: 'allas',
  ELLE: 'elle',
  SVENSKDAM: 'svenskdam',
  RESIDENCE: 'residence',
} as const;

export type BRAND = (typeof BRANDS)[keyof typeof BRANDS];

export const SECTIONS = {
  TOP: 'top',
  TRENDING: 'trending',
  TAGS: 'tags',
  SHOWS: 'shows',
  NEW: 'new',
} as const;

export type SECTION = (typeof SECTIONS)[keyof typeof SECTIONS];

export interface VideoTag {
  name: string;
  redirectTo?: string;
  isGone?: boolean;
  isTech?: boolean;
}

export interface Playlist {
  title: string;
  mediaId: string;
  image: string;
  url: string;
  pubdate: number;
  description?: string;
  prominentTag?: string;
  isVertical?: boolean;
}

export interface VideoFrontSectionData {
  title?: string;
  description?: string;
  playlist_category: string;
  playlist: Playlist[];
  url?: string;
}

export interface VideoFrontSection {
  type: SECTION;
  data: VideoFrontSectionData[];
}

export interface TagsList {
  tagsList: {
    description: string;
    content: string;
    playlistId: string;
    url: string;
  }[];
}

/// media types

export type Transcription = {
  start: string;
  end: string;
  text: string[];
};

export interface MediaItem {
  title: string;
  description: string;
  file?: string;
  kind: string;
  playlist: MediaPlaylist[];
  seo_beskrivning?: string;
  seo_title?: string;
  feed_instance_id: string;
  transcriptionData: Transcription[];
}

export interface MediaPlaylist {
  title: string;
  mediaid: string;
  link: string;
  image: string;
  images: {
    src: string;
    width: number;
    type: string;
  }[];
  feedid: string;
  duration: number;
  pubdate: number;
  description: string;
  tags: string;
  prominentTag?: string;
  objectTags: VideoTag[];
  sources: {
    file: string;
    type: string;
    height?: number;
    width?: number;
    label?: string;
    bitrate?: number;
    filesize?: number;
    framerate?: number;
  }[];
  tracks: {
    file: string;
    kind: string;
  }[];
  variations: Record<string, any>;
  brand: string;
  brand_verticals: string;
  canonical_brand: string;
  creator: string;
  mentions: string;
  shoppable_video: string;
  video_advertiser: string;
  video_category1: string;
  video_category2: string;
  video_comm_ad_text: string;
  video_comm_link: string;
  video_comm_link_text: string;
}

export interface Show {
  title: string;
  description: string;
  playlist_category: 'show';
  image: string;
}
